import React, { useState } from "react";
import "./App.css";
import About from "./pages/About";
import Home from "./pages/Home";
import { BrowserRouter as Router, Route, Routes, Link, Navigate, } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import Submenu from "./Components/menu/Submenu";
import { Col, Container, Row } from "react-bootstrap";
import { Icon } from "@iconify/react";
import Footer from "./Components/footer/Footer";
import BrandedMerchandise from "./pages/Branded-merchandise";
import FestiveGifitng from "./pages/Festive-gifting";
import CorporateGifting from "./pages/Branded-merchandise/Corporate-gifting";
import CustomizedGifts from "./pages/Customized-gifts";
import EcofriendlyGifts from "./pages/Eco-friendly-gifts";
import EmployeeRecognition from "./pages/Employee-recognition";
import CompanyStore from "./pages/Company-store";
import AbouteYantra from "./pages/Who-We-are/About-eyantra";
import Responsibility from "./pages/Who-We-are/Responsibility";
import Ourwork from "./pages/Our-work/Our-work";
import Contactus from "./pages/Contact/Contact-us";
import EmployeeGifts from "./pages/Branded-merchandise/Employee-gifts";
import EventGifts from "./pages/Branded-merchandise/Events-gifts";
import ExperientialGifitng from "./pages/Branded-merchandise/Experiential-gifting";
import NewYeargifts from "./pages/Festive-gifting/New-year-gifts";
import DiwaliGifts from "./pages/Festive-gifting/Diwali-gifts";
import ChirstmasGifts from "./pages/Festive-gifting/Chirstmas-gifts";
import OtherfestiveGifts from "./pages/Festive-gifting/Other-festive-gifts";
import CustomizedgiftswithCompanyBranding from "./pages/Customized-gifts/Customized-gifts-with-company-branding";
import CustomizedgiftswithoutCompanyBranding from "./pages/Customized-gifts/Customized-gifts-without-company-branding";
import EcofriendlyGiftsforcorporategifting from "./pages/Eco-friendly-gifts/Eco-friendly-gifts-for-corporate-gifting";
import EcofriendlyGiftsforemployees from "./pages/Eco-friendly-gifts/Eco-friendly-gifts for-employees";
import EcofriendlyGiftsforclientsandevents from "./pages/Eco-friendly-gifts/Eco-friendly-gifts-for-clients-and-events";
import EcofriendlyGiftsforalloccasions from "./pages/Eco-friendly-gifts/Eco-friendly-gifts-for-all-occasions";
import Joiningkits from "./pages/Employee-recognition/Joining-kits";
import Welcomekits from "./pages/Employee-recognition/Welcome-kits";
import Rewardsandrecognition from "./pages/Employee-recognition/Rewards-and-recognition";
import BrandStore from "./pages/company-stores/Brand-store";
import Officesupplies from "./pages/company-stores/Office-supplies";
import Newyearcatalog from "./pages/Catalog/New-year-catalog";
import DiwaliCatalog from "./pages/Catalog/Diwali-catalog";
import Otherbrandcatalog from "./pages/Catalog/Other-brand-catalog";
import GiftingReports from "./pages/gifting-report/Gifting-report";
import MobileMenu from "./Components/menu/Mobile-menu";
import ScrolltoTop from "./Scrolltotop";
import Notfound from "./Notfound";
import LaunchingSoon from "./LaunchingSoon";
import Privacypolicy from "./pages/Policy-pages/Privacy-policy";
import Termsandconditions from "./pages/Policy-pages/Terms-and-Conditions";
import OnlineReturnPolicy from "./pages/Policy-pages/Online-return-policy";
import Shippingpolicy from "./pages/Policy-pages/Shipping-policy";
import Thankyou from "./pages/Thank-you/thank-you";
import ScrollToHash from "./ScrolltoHash";
import RedirectComponent from "./Replace";

const App = () => {
  const [visibleSubmenu, setVisibleSubmenu] = useState(null);

  const handleSubmenuClick = (submenuId) => {
    setVisibleSubmenu((prevSubmenu) =>
      prevSubmenu === submenuId ? null : submenuId
    );
  };

  // Menu data
  const whatWedoMenus = [
    { label: "Branded Merchandise", link: "/branded-merchandise" },
    { label: "Festive Gifting", link: "/festive-gifting" },
    { label: "Customized Gifts", link: "/customized-gifts" },
    { label: "Eco-Friendly Gifts", link: "/eco-friendly-gifts" },
    { label: "Employee Recognition", link: "/employee-recognition" },
    { label: "Company Store", link: "/company-store" },
  ];

  const whatWedoSubmenus = [
    {
      imgSrc: "../assests/images/drop-down-images/Branded Merchandise.jpg",
      ParentMenuLabel: "Branded Merchandise",
      ParentMenuDescription:
        "At eYantra, we specialize in creating impactful branded merchandise solutions that go beyond the ordinary. Whether you’re looking to engage employees, impress clients, or uplift your events, our expertise in corporate gifting, employee gifts, event gifts, and experiential gifting makes sure every experience is memorable and meaningful.",
      ParentLink: "/branded-merchandise",
      solutions:[
          {Heading:"SOLUTIONS", solutionsLabel:"Corporate Gifting", SolutionLink:"/branded-merchandise/corporate-gifting"},
          {solutionsLabel:"Employee Gifts", SolutionLink:"/branded-merchandise/employee-gifts"},
          {solutionsLabel:"Event Gifts", SolutionLink:"/branded-merchandise/event-gifts"},
          {solutionsLabel:"Experiential Gifting", SolutionLink:"/branded-merchandise/experiential-gifting"},
        
      ]
    },
    {
      imgSrc: "../assests/images/drop-down-images/Festive Giftings.jpg",
      ParentMenuLabel: "Festive Gifting",
      ParentMenuDescription:
        "Festivals are more than just occasions – they’re opportunities to strengthen bonds, spark joy, and create a lasting impression. At eYantra, our Festive Gifting Solutions are designed to help your brand shine through thoughtful, high-quality, and memorable gifts for every celebration.",
      ParentLink: "/festive-gifting",
      solutions:[
          {Heading:"SOLUTIONS", solutionsLabel:"New Year Gifts", SolutionLink:"/festive-gifting/new-year-gifts"},
          {solutionsLabel:"Diwali Gifts", SolutionLink:"/festive-gifting/diwali-gifts"},
          {solutionsLabel:"Christmas Gifts", SolutionLink:"/festive-gifting/christmas-gifts"},
          {solutionsLabel:"Other Festive Gifts", SolutionLink:"/festive-gifting/other-festive-gifts"}, 
      ]
    },
    {
      imgSrc: "../assests/images/drop-down-images/Customized Gifts.jpg",
      ParentMenuLabel: "Customize Gifts",
      ParentMenuDescription:
        "At eYantra, we believe in the power of personalization. Customized gifts are a powerful way to connect, engage, and leave a lasting impression on your audience. Whether you're looking to showcase your company’s branding or offer a more personal touch, our customized gifting solutions bring your ideas to life in the most meaningful way.",
      ParentLink: "/customized-gifts",
      solutions:[
          {Heading:"SOLUTIONS", solutionsLabel:"Customized Gifts with Company Branding", SolutionLink:"/customized-gifts/customized-gifts-with-company-branding"},
          {solutionsLabel:"Customized Gifts without Company Branding", SolutionLink:"/customized-gifts/customized-gifts-without-company-branding"},
      ]
    },
    {
      imgSrc: "../assests/images/drop-down-images/Eco-Friendly Gifts.jpg",
      ParentMenuLabel: "Eco-Friendly Gifts",
      ParentMenuDescription:
        "eYantra believes that gifting can be both meaningful and responsible. Our Eco-Friendly Gifts are designed to reflect your commitment to sustainability while still delivering an impactful and memorable experience. Whether you're looking to impress clients, reward employees, or celebrate a special occasion, our eco-conscious options makes sure you make a positive difference.",
      ParentLink: "/eco-friendly-gifts",
      solutions:[
          {Heading:"SOLUTIONS", solutionsLabel:"Eco-Friendly Gifts for Corporate Gifting", SolutionLink:"/eco-friendly-gifts/eco-friendly-gifts-for-corporate-gifting"},
          {solutionsLabel:"Eco-Friendly Gifts for Employees", SolutionLink:"/eco-friendly-gifts/eco-friendly-gifts-for-employees"},
          {solutionsLabel:"Eco-Friendly Gifts for Clients and Events", SolutionLink:"/eco-friendly-gifts/eco-friendly-gifts-for-clients-and-events"},
          {solutionsLabel:"Eco-Friendly Gifts for All Occasions", SolutionLink:"/eco-friendly-gifts/eco-friendly-gifts-for-all-occasions"},
      ]
    },
    {
      imgSrc: "../assests/images/drop-down-images/Employee Recognition.jpg",
      ParentMenuLabel: "Employee Recognition",
      ParentMenuDescription:
        "At eYantra, we understand that employees are the backbone of any successful organization. That's why our Employee Recognition Solutions are crafted to help you appreciate and celebrate your team in ways that inspire loyalty, motivation, and pride. Whether it's a warm welcome, a thoughtful reward, or a recognition program that keeps spirits high, we have you covered every step of the way.",
      ParentLink: "/employee-recognition",
      solutions:[
          {Heading:"SOLUTIONS", solutionsLabel:"Joining Kits", SolutionLink:"/employee-recognition/joining-kits"},
          {solutionsLabel:"Welcome Kits", SolutionLink:"/employee-recognition/welcome-kits"},
          {solutionsLabel:"Rewards & Recognition (R&R)", SolutionLink:"/employee-recognition/reward-and-recognition"},
      ]
    },
    {
      imgSrc: "../assests/images/drop-down-images/Company Stores.jpg",
      ParentMenuLabel: "Company Stores",
      ParentMenuDescription:
        "eYantra makes it easy for businesses to build a unified, branded experience through Company Stores. Whether you’re looking to showcase your brand’s merchandise or streamline the distribution of essential office supplies, our tailored solutions make sure convenience, efficiency, and style – all in one place.",
      ParentLink: "/company-store",
      solutions:[
          {Heading:"SOLUTIONS", solutionsLabel:"Brand Store", SolutionLink:"/company-store/brand-store"},
          {solutionsLabel:"Office Supplies", SolutionLink:"/company-store/office-supplies"},
      ]
    },
  ];
 

  const whoWeareMenus = [
    { label: "Who We are", link: "/who-we-are/about-eyantra" },
    { label: "Responsibility", link: "/who-we-are/responsibility" },
  ];
  const whoWeareSubMenus = [
    {
      imgSrc: "../assests/images/drop-down-images/whoweare.jpg",
      ParentMenuLabel: "Who We are",
      ParentMenuDescription:
        "At eYantra, our goal is simple yet impactful: to encourage businesses by creating memorable corporate gifting experiences. We specialize in branded merchandise, corporate gifting, and innovative recognition solutions designed to leave a lasting impression. Whether it’s employee gifts, joining kits, or festive gifting, we aim to bridge the gap between brands and their employees, creating connections that inspire loyalty and drive success.",
      ParentLink: "/who-we-are/about-eyantra",
      solutions:[
          {Heading:"About eYantra", solutionsLabel:"Culture of Work", SolutionLink:"/who-we-are/about-eyantra#culture-of-work"},
          {solutionsLabel:"Leadership", SolutionLink:"/who-we-are/about-eyantra#leadership"},
          {solutionsLabel:"Locations", SolutionLink:"/who-we-are/about-eyantra#locations"},
      ]
    },
    {
      imgSrc: "../assests/images/drop-down-images/Responsibility.jpg",
      ParentMenuLabel: "Responsibility",
      ParentMenuDescription:
        "At eYantra, sustainability isn’t just a buzzword – it’s at the heart of everything we do. We are committed to making a meaningful difference by creating environmentally responsible solutions that benefit both businesses and the planet. From sourcing eco-friendly materials for our corporate gifting products to implementing energy-efficient practices in our operations, we make sure that every decision we make reflects our dedication to a sustainable future.",
      ParentLink: "/who-we-are/about-eyantra",
      solutions:[
          {Heading:"About eYantra", solutionsLabel:"Sustainability", SolutionLink:"/who-we-are/responsibility"},
          {solutionsLabel:"Safety and Compliance ", SolutionLink:"/who-we-are/responsibility"},
      ]
    },
  ]
  

  const catalogsMenus = [
    { label: "New Year Catalog", link: "/catalog/new-year" },
    { label: "Diwali Catalog", link: "/catalog/diwali" },
    { label: "Other Brand Catalogs", link: "/catalog/other-brand-catalog" },
  ];

  const CatalogSubMenus = [
    {
      imgSrc: "../assests/images/drop-down-images/New-Year Catalog.jpg",
      ParentMenuLabel: "New Year Catalog",
      ParentMenuDescription:
        "Ring in the New Year with thoughtful corporate gifts! Our curated selection includes elegant hampers, personalized accessories, and premium gift sets to strengthen business relationships.",
      ParentLink: "/catalog/new-year",
      solutions:[
          {Heading:"Gifting Range", solutionsLabel:"Diwali Catalog", SolutionLink:"/catalog/diwali"},
          {solutionsLabel:"Other Brand Catalogs", SolutionLink:"/catalog/other-brand-catalog"},
      ]
    },
    {
      imgSrc: "../assests/images/drop-down-images/Diwali Catalog.jpg",
      ParentMenuLabel: "Diwali Catalog",
      ParentMenuDescription:
        "Celebrate the festival of lights with our exquisite Diwali gifting range. From gourmet treats to luxury hampers, find the perfect gifts to brighten corporate celebrations.",
      ParentLink: "/catalog/diwali",
      solutions:[
          {Heading:"Gifting Range", solutionsLabel:"New Year Catalog", SolutionLink:"/catalog/new-year"},
          {solutionsLabel:"Other Brand Catalogs", SolutionLink:"/catalog/other-brand-catalog"},
      ]
    },
    {
      imgSrc: "../assests/images/drop-down-images/Other Brand.jpg",
      ParentMenuLabel: "Other Brand Catalogs",
      ParentMenuDescription:
        "Discover top-brand gifts across categories like electronics, lifestyle, and wellness. Upgrade your corporate gifting with trusted, high-quality products from leading brands.",
      ParentLink: "/catalog/other-brand-catalog",
      solutions:[
          {Heading:"Gifting Range", solutionsLabel:"New Year Catalog", SolutionLink:"/catalog/new-year"},
          {solutionsLabel:"Diwali Catalog", SolutionLink:"/catalog/diwali"},
      ]
    },
  ]

  const resourcesMenus = [
    { label: "Featured Blogs", link: "/launching-soon" },
    { label: "Latest Blogs", link: "/launching-soon" },
  ];
  const resourcesSubMenu = [
    {
      imgSrc: "../assests/images/sub-pages/custom-branding.png",
      ParentMenuLabel: "Featured Blogs",
      ParentMenuDescription:
        "Read our newest articles on corporate gifting, employee appreciation, and festive gifting ideas tailored for businesses.",
      ParentLink: "/launching-soon",
      solutions:[
          {Heading:"", solutionsLabel:"Latest Blogs", SolutionLink:"/launching-soon"},
      ]
    },
    {
      imgSrc: "../assests/images/sub-pages/custom-branding.png",
      ParentMenuLabel: "Latest Blogs",
      ParentMenuDescription:
        "Explore our curated blogs covering the latest trends, best practices, and innovative ideas in corporate gifting, joining kits, brand store and what not.",
      ParentLink: "/launching-soon",
      solutions:[
          {Heading:"", solutionsLabel:"Blogs", SolutionLink:"/launching-soon"},
      ]
    },
  ]

  const handleMouseLeave = () => {
    setVisibleSubmenu(null); // Hide the submenu when mouse leaves
  };


  return (
    <>
    
      <Router>
      <ScrollToHash/>
        <ScrolltoTop/>
        <RedirectComponent/>
        <div className="container-fluid pt-5 px-0 mt-3">
          <div className="fixed-top d-md-block d-none " >
            <nav className="navbar navbar-expand-lg navbar-light bg-white shadow-sm">
              <Container className="p-0">
                <a className="navbar-brand" href="/">
                  <img src="../assests/eyantra_logo.svg" alt="Eyantra Logo" loading="lazy"/>
                </a>
                <button
                  className="navbar-toggler"
                  type="button"
                  data-toggle="collapse"
                  data-target="#navbarSupportedContent"
                  aria-controls="navbarSupportedContent"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <span className="navbar-toggler-icon" />
                </button>
                <div
                  className="collapse navbar-collapse "
                  id="navbarSupportedContent"
                >
                  <ul className="navbar-nav mr-auto justify-content-around w-100 align-items-center">
                    {/* What We Do Submenu */}
                    <li>
                      <div
                        // className="Menu"
                        className={`Menu ${visibleSubmenu === "whatWedo" ? "active" : ""}`}
                        
                        onClick={() => handleSubmenuClick("whatWedo")}
                      >
                        <Link  className="nav-link fw-bold" to="#">
                          What We Do
                          <Icon
                            icon="tabler:chevron-down"
                            width="22"
                            height="22"
                          />
                        </Link>
                        <span onMouseLeave={handleMouseLeave}>
                        {visibleSubmenu === "whatWedo" && (
                          <Submenu
                            items={whatWedoMenus}
                            subMenus={whatWedoSubmenus}
                           
                          />
                        )}
                        </span>
                      </div>
                    </li>

                    {/* Who We Are Submenu */}
                    <li>
                      <div
                        // className="Menu"
                        className={`Menu ${visibleSubmenu === "whoWeare" ? "active" : ""}`}
                        onClick={() => handleSubmenuClick("whoWeare")}
                      >
                        <Link className="nav-link fw-bold" to="#">
                          Who We Are
                          <Icon
                            icon="tabler:chevron-down"
                            width="22"
                            height="22"
                          />
                        </Link>
                        <span onMouseLeave={handleMouseLeave}>
                        {visibleSubmenu === "whoWeare" && (
                          <Submenu
                            items={whoWeareMenus}
                            subMenus={whoWeareSubMenus}
                          />
                        )}
                        </span>
                      </div>
                    </li>

                    {/* Our Work Submenu */}
                    <li>
                      <div 
                      // className="Menu"
                      
                      >
                        <Link
                          className="nav-link fw-bold"
                          // className={`nav-link fw-bold ${location.pathname === "/our-work" ? "active" : ""}`}
                          to="/our-work"
                        >
                          Our Work
                        </Link>
                      </div>
                    </li>

                    {/* Catalogs Submenu */}
                    <li>
                      <div
                        // className="Menu"
                        className={`Menu ${visibleSubmenu === "catalogs" ? "active" : ""}`}
                        onClick={() => handleSubmenuClick("catalogs")}
                      >
                        <Link className="nav-link fw-bold" to="#">
                          Catalogs 
                          <Icon
                            icon="tabler:chevron-down"
                            width="22"
                            height="22"
                          />
                        </Link>
                        <span onMouseLeave={handleMouseLeave}>
                        {visibleSubmenu === "catalogs" && (
                          <Submenu
                            items={catalogsMenus}
                            subMenus={CatalogSubMenus}
                          />
                        )}
                        </span>
                      </div>
                    </li>

                    {/* Resources Submenu */}
                    <li>
                      <div
                        // className="Menu"
                        className={`Menu ${visibleSubmenu === "resources" ? "active" : ""}`}
                        onClick={() => handleSubmenuClick("resources")}
                      >
                        <Link className="nav-link fw-bold" to="#">
                          Resources
                          <Icon
                            icon="tabler:chevron-down"
                            width="22"
                            height="22"
                          />
                        </Link>
                        <span onMouseLeave={handleMouseLeave}>
                        {visibleSubmenu === "resources" && (
                          <Submenu
                            items={resourcesMenus}
                            subMenus={resourcesSubMenu}
                          />
                        )}
                        </span>
                      </div>
                    </li>

                    {/* Gifting Reports Submenu */}
                    <li>
                      <div
                        className="Menu"
                        onClick={() => handleSubmenuClick("gifitingreports")}
                      >
                       <Link
                          className="nav-link fw-bold"
                          to="/gifting-report-2024"
                        >
                          Gifting Report 2024
                        </Link>
                        
                      </div>
                    </li>

                    {/* Contact Us Button */}
                    <li>
                      <button className="btn btn-primary" id="btnCTA">
                        <Link
                          className="nav-link fw-bold text-white p-0 m-0"
                          to="/contact-us"
                        >
                          Contact Us
                        </Link>
                      </button>
                    </li>
                  </ul>
                </div>
              </Container>
            </nav>
          </div>
          {/**Mobile Menu */}
        
          <div className="fixed-top d-md-none d-block " >
            <nav className="navbar navbar-expand-lg navbar-light bg-white shadow-sm">
              <Container className="">
                <Row className="justify-content-end d-flex w-100 align-items-center">
                <Col className="col-3">
                <a className="navbar-brand" href="/">
                  <img src="../assests/images/eyantra_logo.svg" alt="Eyantra Logo" loading="lazy"/>
                </a>
                </Col>
                <Col className="col-9 text-end">
                        <MobileMenu/>
                
                </Col>
                </Row>

               
              </Container>
            </nav>
          </div>
         
          {/**Mobile Menu */}
    
          <Routes>
            <Route path="/" element={<Home />} />
            
            <Route path="/about" element={<About />} />
            <Route
              path="/branded-merchandise"
              element={<BrandedMerchandise />}
            />
            {/**Internal pages */}
            <Route
              path="/branded-merchandise/corporate-gifting"
              element={<CorporateGifting />}
            />
            <Route
              path="/branded-merchandise/employee-gifts"
              element={<EmployeeGifts />}
            />
            <Route
              path="/branded-merchandise/event-gifts"
              element={<EventGifts />}
            />
            <Route
              path="/branded-merchandise/experiential-gifting"
              element={<ExperientialGifitng />}
            />
            {/**End Branded Merchandise Internal pages */}
            <Route path="/festive-gifting" element={<FestiveGifitng />} />
            <Route
              path="/festive-gifting/new-year-gifts"
              element={<NewYeargifts />}
            />
            <Route
              path="/festive-gifting/diwali-gifts"
              element={<DiwaliGifts />}
            />
            <Route
              path="/festive-gifting/christmas-gifts"
              element={<ChirstmasGifts />}
            />
            <Route
              path="/festive-gifting/other-festive-gifts"
              element={<OtherfestiveGifts />}
            />
            {/**End Festive Gifting Internal pages */}
            <Route path="/customized-gifts" element={<CustomizedGifts />} />
            <Route
              path="/customized-gifts/customized-gifts-with-company-branding"
              element={<CustomizedgiftswithCompanyBranding />}
            /> 
            <Route
              path="/customized-gifts/customized-gifts-without-company-branding"
              element={<CustomizedgiftswithoutCompanyBranding />}
            /> 
             {/**End Customized gifts Internal pages */}
            <Route path="/eco-friendly-gifts" element={<EcofriendlyGifts />} />
            <Route
              path="/eco-friendly-gifts/eco-friendly-gifts-for-corporate-gifting"
              element={<EcofriendlyGiftsforcorporategifting/>}
            /> 
            <Route
              path="/eco-friendly-gifts/eco-friendly-gifts-for-employees"
              element={<EcofriendlyGiftsforemployees/>}
            /> 
            <Route
              path="/eco-friendly-gifts/eco-friendly-gifts-for-clients-and-events"
              element={<EcofriendlyGiftsforclientsandevents/>}
            /> 
            <Route
              path="/eco-friendly-gifts/eco-friendly-gifts-for-all-occasions"
              element={<EcofriendlyGiftsforalloccasions/>}
            />
            {/**End Customized gifts Internal pages */}
            
            <Route
              path="/employee-recognition"
              element={<EmployeeRecognition />}
            />
            <Route path="/pages/joining-kits" element={<Navigate/>}/>
            <Route
              path="/employee-recognition/joining-kits"
              element={<Joiningkits/>}
            />
            <Route
              path="/employee-recognition/welcome-kits"
              element={<Welcomekits/>}
            />
             <Route
              path="/employee-recognition/reward-and-recognition"
              element={<Rewardsandrecognition/>}
            />
           
            <Route path="/company-store" element={<CompanyStore />} />
            <Route
              path="/company-store/brand-store"
              element={<BrandStore/>}
            />
            <Route
              path="/company-store/office-supplies"
              element={<Officesupplies/>}
            />

            {/**Who we are */}
            <Route
              path="/who-we-are/about-eyantra"
              element={<AbouteYantra />}
            />
            <Route
              path="/who-we-are/responsibility"
              element={<Responsibility />}
            />
            
            {/**Catalogs */}

            <Route path="/catalog/new-year" element={<Newyearcatalog />} />
            <Route path="/catalog/diwali" element={<DiwaliCatalog/>} />
            <Route path="/catalog/other-brand-catalog" element={<Otherbrandcatalog />} />

            {/**Our Work */}
            <Route path="/our-work" element={<Ourwork />} />
           

            {/**Report  */}
            
            <Route path="/gifting-report-2024" element={<GiftingReports />} />
            
            <Route path="/launching-soon" element={<LaunchingSoon/>}/>

            {/**Contact us */}

            <Route path="/contact-us" element={<Contactus />} />
            {/**Policy pages */}
            <Route path="/privacy-policy" element={<Privacypolicy/>}/>
            <Route path="/terms-and-conditions" element={<Termsandconditions/>}/>
            <Route path="/online-return-policy" element={<OnlineReturnPolicy/>}/>
            <Route path="/shipping-policy" element={<Shippingpolicy/>}/>
            <Route path="/thank-you" element={<Thankyou/>}/>
            <Route path="*" element={<Notfound/>}/>
          </Routes>
        </div>

        
      </Router>

      <footer>
        <Footer />
      </footer>
    </>
  );
};

export default App;
